import React from 'react';
import { SectionLabel } from './SectionLabel';
import { Bloom } from './Bloom';
import { DeviceMockup } from './visuals/DeviceMockup';
import { automations } from '../data/howItWorks';

/* 2026-09-10 (compliance, Kevin): the third chat line used to thank the
   customer for a 5-star review. Yelp flagged Viridia for review
   solicitation a second time. Replaced with a review-free confirmation
   line. Do not reinstate review-request copy in this mockup. */
const chatLines = [{
  from: 'system' as const,
  text: "Hey Maria, still good for your estimate tomorrow at 10am?"
}, {
  from: 'customer' as const,
  text: "Yes! See you then"
}, {
  from: 'system' as const,
  text: "Great, we'll see you then. Text us anytime before if anything changes."
}];

/* Pairs the automations list with a real text-thread mockup instead of a
   third text-card grid -- the section's own copy ("a lead that goes quiet
   gets chased on its own") is exactly what a follow-up/reminder thread
   looks like, so showing one is more convincing than another bullet list.
   Visual sits first on desktop for rhythm against the CRM section above it
   (visual-then-text there, text-then-visual here). */
export function AutomationsSection() {
  return <section className="relative isolate overflow-hidden border-b border-[#1a1a1a]" data-id="element-158" data-mp="2cfp6cl7j4yhy">
      <Bloom size="md" className="right-0 top-[-6rem]" data-id="element-159" data-mp="27et40c2ttken" />
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 items-center gap-14 px-6 py-20 lg:grid-cols-2 lg:py-24" data-id="element-160" data-mp="2lfm194kiitlg">
        <div className="order-first lg:order-none" data-id="element-161" data-mp="2gh2fp59tzjtm">
          <DeviceMockup mode="chat" heading="Automated follow-up" lines={chatLines} data-id="element-162" data-mp="2gg96lxnegi8b" />
        </div>
        <div data-id="element-163" data-mp="2v4nj70ambl22">
          <SectionLabel data-id="element-164" data-mp="2v79lakeqp8cw">Automations</SectionLabel>
          <h2 className="mt-8 text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-165" data-mp="2q7dk0sxffv11">
            Nobody goes cold because you got busy.
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-neutral-400" data-id="element-166" data-mp="304rzoqbj0fsa">
            Built with you on a call, in your voice. Then they run without you.
          </p>
          <ul className="mt-8 space-y-4" data-id="element-167" data-mp="375lqea74l7ae">
            {automations.map(f => <li key={f.title} className="flex gap-3 text-sm leading-relaxed text-neutral-300" data-id="element-168" data-mp="3c7b0nnmixgxf">
                <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-emerald-500" aria-hidden="true" data-id="element-169" data-mp="3h4bbebubj7uv" />
                <span data-id="element-170" data-mp="3pypnk5jjy29r">
                  <span className="font-semibold text-white" data-id="element-171" data-mp="3pxei81agkmgj">{f.title}.</span> {f.body}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}